import { xmllibtranslate } from "./xml-lib/xml-lib-translate.js";

// Example Usage:

// const langData = cloudTranslate.screen(
//     document.querySelectorAll("[translate] *")
//   );

//   langList.forEach((elem) => {
//     elem.addEventListener("click", () => {
//       cloudTranslate.init(elem.dataset.lang, langData);
//     });
//   });

export const cloudTranslate = {
  screen: function (langData) {
    var array = [];

    var elements = langData;

    for (var i = 0; i < elements.length; i++) {
      var current = elements[i];
      if (
        current.children.length === 0 &&
        current.textContent.replace(/ |\n/g, "") !== ""
      ) {
        // Check the element has no children && that it is not empty
        array.push({ node: current, content: current.textContent });
      }
    }
    return array;
  },
  init: function (lang, array, url) {
    //xmllibtranslate.get("Hello", "fr");
    // array.forEach((arr) => {

    xmllibtranslate.get(array, lang, url);
    // });
  },
};
